import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";

/**
 * OAuth Callback Page
 * Handles the redirect from OAuth providers (Google, etc.)
 * Saves the token and redirects based on profile completion status
 */
export const OAuthCallback = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const handleCallback = () => {
      const token = searchParams.get("token");
      const profileCompleted = searchParams.get("profile_completed");
      const userRole = searchParams.get("user_role");
      const error = searchParams.get("error");

      // Check for errors
      if (error) {
        console.error("OAuth error:", error);
        navigate("/login?error=" + error);
        return;
      }

      // Check for token
      if (!token) {
        console.error("No token received from OAuth");
        navigate("/login?error=no_token");
        return;
      }

      // Save token to localStorage
      localStorage.setItem("token", token);

      // Trigger auth check by dispatching custom event
      window.dispatchEvent(new Event("auth-change"));

      // Redirect based on profile completion and user role
      if (profileCompleted === "false") {
        // Profile not complete - redirect to complete profile page
        navigate("/complete-profile");
      } else if (userRole === "admin") {
        // Admin user - redirect to admin dashboard
        navigate("/admin");
      } else if (userRole === "investor") {
        // Investor - redirect to opportunities (future)
        navigate("/opportunities");
      } else {
        // Homeowner - redirect to search
        navigate("/search");
      }
    };

    handleCallback();
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <Loader2 className="w-12 h-12 animate-spin text-primary mx-auto" />
        <p className="mt-4 text-muted-foreground">Completing sign in...</p>
      </div>
    </div>
  );
};

export default OAuthCallback;
